// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3NM57","label":"SetPasswdForm_label__bagjl"};